export const SILENT_RENEW_ERROR = "redux-oidc/SILENT_RENEW_ERROR";
export const USER_SIGNED_OUT = "redux-oidc/USER_SIGNED_OUT";


// WEBPACK FOOTER //
// ./src/oidc/oidcActionTypes.js